import React, { useState } from 'react'
import Header from '../../headerone/Main'
import Bredcom from '../../Bredcom/Main'

function LawMediaAttention() {

    const Data = [        
        {img : "https://admission.mvn.edu.in/wp-content/uploads/2021/08/school-of-law-media-1.jpg", category : "Financial"},
        {img : "https://admission.mvn.edu.in/wp-content/uploads/2021/08/school-of-law-media-2.jpg", category : "Financial"},
        {img : "https://admission.mvn.edu.in/wp-content/uploads/2021/08/school-of-law-media-3.jpg", category : "Financial"},
        {img : "https://admission.mvn.edu.in/wp-content/uploads/2021/08/school-of-law-media-4.jpg", category : "Financial"},
        {img : "https://admission.mvn.edu.in/wp-content/uploads/2021/08/school-of-law-media-5.jpg", category : "Financial"},
        {img : "https://admission.mvn.edu.in/wp-content/uploads/2021/08/school-of-law-media-6.jpg", category : "Financial"},
        
      ]

      const [current, setcurrent] = useState(Data);

    
    return (
        <>
            <Header />
            <Bredcom title="Home/ School of Law" subtitle="Media Attention" />
            <section className="about-area about-p pt-120 pb-120 p-relative fix">
                <div className="animations-02">
                    <img src="/assets/img/bg/an-img-02.png" alt="contact-bg-an-01" />
                </div>
                <div className="container">
                    <div className="row justify-content-center align-items-center">                        
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="about-content s-about-content pl-15 wow fadeInRight  animated" data-animation="fadeInRight" data-delay=".4s" >
                                
                                <div className="row fadeInUp  animated pt-25" data-animation="fadeInUp" data-delay=".4s" >
                                    {current.map( (item, Index)=> ( 
                                        <div className="col-md-3 col-sm-6" style={{padding:'15px'}} key={Index}>
                                                    <img src={item.img} alt="img" className='healthImg' />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default LawMediaAttention